<div class="vehicle-title-component" [class.always-stacked]="always_stacked">
	<div class="vehicle-title" [ngClass]="{ 'vehicle-title-valuation-modal-view': isValuationModalView }">
		<!--  BRAND  -->

		<div class="brand-container">
			<img
				*ngIf="imageErrorCount < 2"
				[attr.src]="vehicle.brand_logo_url"
				[attr.alt]="vehicle.make"
				src="//:0"
				(error)="onImageError($event.target)"
			/>
		</div>

		<!--  END BRAND  -->

		<!--  VEHICLE TITLE  -->

		<div
			class="title-container"
			[ngClass]="{
				'has-cta': show_cta,
				'has-registration': show_registration,
				'has-edition': vehicle.edition !== null
			}"
		>
			<h3 class="make-model">
				{{ vehicle.make }}
				<span *ngIf="vehicle.model !== null">{{ vehicle.model }}</span>
			</h3>
			<p *ngIf="vehicle.edition !== null" class="variant">{{ vehicle.edition }}</p>
		</div>

		<!--  END VEHICLE TITLE  -->

		<!--  CTA  -->

		<div *ngIf="show_cta" class="cta-container">
			<a class="button" (click)="onCtaClick()">
				<span *ngIf="!cta_loading">{{ cta_text }}</span>
				<span *ngIf="cta_loading" class="loading-spinner"></span>
			</a>
		</div>

		<!--  END CTA  -->

		<!--  REGISTRATION  -->

		<div *ngIf="vehicle.registration && show_registration" class="registration-container">
			<div class="number-plate">
				<h3>{{ vehicle.registration }}</h3>
			</div>
		</div>

		<!--  END REGISTRATION  -->

		<!--  ICON LIST  -->

		<div *ngIf="show_icon_list" class="icon-list-container">
			<ui-icon-list [vehicle]="vehicle"></ui-icon-list>
		</div>

		<!--  END ICON LIST  -->

		<!--  PRICING INFO - FINANCE -->

		<div *ngIf="vehicle.regular_payment !== null && show_price" class="price-container row">
			<div class="col-total-title align-left" [ngClass]="vehicle.add_vat ? 'col-xxs-12 col-xs-14' : 'col-xxs-14'">
				Monthly Cost
			</div>
			<div
				class="col-xxs-offset-2 col-total-title align-right"
				[ngClass]="vehicle.add_vat ? 'col-xxs-16 col-xs-14' : 'col-xxs-14'"
			>
				Cash Price
			</div>
			<div class="col-finance text-hl" [ngClass]="vehicle.add_vat ? 'col-xxs-12 col-xs-14' : 'col-xxs-14'">
				{{ vehicle.regular_payment | money }}
				<small>P/M</small>
			</div>
			<div class="col-xxs-2 align-center col-or">
				<span>or</span>
			</div>
			<div class="col-cash text-hl" [ngClass]="vehicle.add_vat ? 'col-xxs-16 col-xs-14' : 'col-xxs-14'">
				{{ vehicle.price | money }}
				<small *ngIf="vehicle.add_vat">+ VAT</small>
			</div>
		</div>

		<!--  END PRICING INFO - FINANCE -->

		<!--  PRICING INFO - NO FINANCE -->

		<div *ngIf="vehicle.regular_payment === null && show_price" class="price-container row no-finance">
			<div class="col-xxs-15 col-total-title" [ngClass]="{ 'col-md-30': !always_stacked }">Cash Price</div>
			<div class="col-xxs-15 col-cash text-hl" [ngClass]="{ 'col-md-30': !always_stacked }">
				{{ vehicle.price | money }}
				<small *ngIf="vehicle.add_vat">+ VAT</small>
			</div>
		</div>

		<!--  END PRICING INFO - NO FINANCE -->
	</div>
</div>
